import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaEvaluacion: moment(new Date()).format('YYYY-MM-DD'),
    proveedorId: 0,
    proveedor: '',
    ordenProveedorId: 0,
    fechaOrdenProveedor: '1900-01-01',
    presupuestoNumero: '',
    presupuestoInterno: '',
    remitoId: 0,
    fechaRemito: '1900-01-01',
    remitoNumero: '',
    calificacionAtencionCliente: 0,
    calificacionTiempoEntrega: 0,
    calificacionCostos: 0,
    calificacionCalidad: 0,
    // calificacion: 0,
    observaciones: '',
    rowVersion: null,

    evaluacionProveedorDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.id = params.evaluacionProveedorId | 0;
        state.proveedorId = 0;
        state.proveedor = '';
        state.ordenProveedorId = params.ordenProveedorId;
        state.fechaOrdenProveedor = '1900-01-01';
        state.presupuestoNumero = '';
        state.presupuestoInterno = '';
        state.remitoId = params.remitoId;
        state.fechaRemito = '1900-01-01';
        state.remitoNumero = '';
        state.calificacionAtencionCliente = 0;
        state.calificacionTiempoEntrega = 0;
        state.calificacionCostos = 0;
        state.calificacionCalidad = 0;
        // state.calificacion = 0;
        state.observaciones = '';
        state.rowVersion = null;
    },
    'SET_DATOS_ORDEN' (state, ordenProveedor) {
        state.proveedorId = ordenProveedor.proveedorId;
        state.proveedor = ordenProveedor.proveedor;
        state.fechaOrdenProveedor = moment(ordenProveedor.fechaComprobante).format('YYYY-MM-DD');
        state.presupuestoNumero = ordenProveedor.presupuestoNumero;
        state.presupuestoInterno = ordenProveedor.presupuestoInterno;
    },
    'SET_DATOS_REMITO' (state, remito) {
        state.proveedorId = remito.transporteId;
        state.proveedor = remito.transporte;
        state.fechaRemito = moment(remito.fechaRemito).format('YYYY-MM-DD');
        state.remitoNumero = remito.remitoNumero;
    },
    'SET_EVALUACION' (state, evaluacionProveedor) {
        state.fechaEvaluacion = moment(evaluacionProveedor.fechaEvaluacion).format('YYYY-MM-DD'),
        state.proveedorId = evaluacionProveedor.proveedorId;
        state.proveedor = evaluacionProveedor.proveedor;
        state.ordenProveedorId = evaluacionProveedor.ordenProveedorId;
        state.fechaOrdenProveedor = moment(evaluacionProveedor.fechaOrdenProveedor).format('YYYY-MM-DD');
        state.presupuestoNumero = ordenProveedor.presupuestoNumero;
        state.presupuestoInterno = ordenProveedor.presupuestoInterno;
        state.calificacionAtencionCliente = evaluacionProveedor.calificacionAtencionCliente;
        state.calificacionTiempoEntrega = evaluacionProveedor.calificacionTiempoEntrega;
        state.calificacionCostos = evaluacionProveedor.calificacionCostos;
        state.calificacionCalidad = evaluacionProveedor.calificacionCalidad;
        // state.calificacion = evaluacionProveedor.calificacion;
        state.observaciones = evaluacionProveedor.observaciones.trim();
        state.rowVersion = evaluacionProveedor.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.evaluacionProveedorDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.evaluacionProveedorDatos = params.evaluacionProveedorDatos;
    },
};

const getters = {
    getField,

};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);
            
            let getEvaluacion = false;
            if (params.evaluacionProveedorId) {
                if (params.evaluacionProveedorId != 0) {
                    getEvaluacion = true;
                }
            }

            if (getEvaluacion) {
                /* Recuperamos los datos de la evaluación */
                apiAxios.get('evaluacionesproveedores/' + params.evaluacionProveedorId + '/abm' ) 
                    .then(res => {
                        commit('SET_EVALUACION', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                if (params.ordenProveedorId != 0) {
                    /* Recuperamos los datos de la orden */
                    apiAxios.get('ordenesproveedores/' + params.ordenProveedorId )
                        .then(res => {
                            commit('SET_DATOS_ORDEN', res.data);
                            resolve();
                        })
                        .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else if (params.remitoId != 0) {
                    /* Recuperamos los datos del remito */
                    apiAxios.get('remitos/' + params.remitoId + '/transporte')
                        .then(res => {
                            commit('SET_DATOS_REMITO', res.data);
                            resolve();
                        })
                        .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else {
                    resolve();
                }
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let evaluacionProveedor= {
                fechaEvaluacion: moment(state.fechaEvaluacion).format('YYYY-MM-DD'),
                proveedorId: parseInt(state.proveedorId),
                ordenProveedorId: parseInt(state.ordenProveedorId),
                remitoId: parseInt(state.remitoId),
                calificacionAtencionCliente: parseInt(state.calificacionAtencionCliente),
                calificacionTiempoEntrega: parseInt(state.calificacionTiempoEntrega),
                calificacionCostos: parseInt(state.calificacionCostos),
                calificacionCalidad: parseInt(state.calificacionCalidad),
                // calificacion: parseInt(state.calificacion),
                observaciones: state.observaciones.trim(),
            };

            let url = 'evaluacionesproveedores';
            if (state.id != 0) {
                url += "/" + state.id;
                evaluacionProveedor.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, evaluacionProveedor)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, evaluacionProveedorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (evaluacionProveedorId) {
                apiAxios.get('evaluacionesproveedores/' + evaluacionProveedorId ) 
                    .then(res => {
                        let evaluacionProveedorDatos = [
                            { 'nombre': 'fechaEvaluacion', 'campo': 'Fecha Evaluación', 'valor': res.data.fechaEvaluacion, 'formato': 'fecha' },
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                        ]

                        if (res.data.ordenProveedorId != 0) {
                            evaluacionProveedorDatos.push(
                                { 'nombre': 'ordenProveedorId', 'campo': 'Nro.Orden', 'valor': res.data.ordenProveedorId, 'formato': '' },
                                { 'nombre': 'presupuestoNumero', 'campo': 'Nro.Presupuesto', 'valor': res.data.presupuestoNumero, 'formato': '' },
                                { 'nombre': 'presupuestoInterno', 'campo': 'Presupuesto Interno', 'valor': res.data.presupuestoInterno, 'formato': '' },
                            )
                        }

                        if (res.data.remitoId != 0) {
                            evaluacionProveedorDatos.push(
                                { 'nombre': 'remitoNumero', 'campo': 'Nro.Remito', 'valor': res.data.remitoNumero, 'formato': '' },
                            )
                        }

                        if (res.data.calificacionGeneral == 0) {
                            evaluacionProveedorDatos.push(
                                { 'nombre': 'calificacionAtencionCliente', 'campo': 'Atención al Cliente', 'valor': res.data.calificacionAtencionCliente, 'formato': '' },
                                { 'nombre': 'calificacionTiempoEntrega', 'campo': 'Tiempo de Entrega', 'valor': res.data.calificacionTiempoEntrega, 'formato': '' },
                                { 'nombre': 'calificacionCostos', 'campo': 'Costos', 'valor': res.data.calificacionCostos, 'formato': '' },
                                { 'nombre': 'calificacionCalidad', 'campo': 'Calidad', 'valor': res.data.calificacionCalidad, 'formato': '' },
                                { 'nombre': 'calificacion', 'campo': 'Calificación Promedio', 'valor': res.data.calificacion, 'formato': 'importe' },
                            );
                        } else {
                            evaluacionProveedorDatos.push(
                                { 'nombre': 'calificacion', 'campo': 'Calificación', 'valor': res.data.calificacion, 'formato': 'importe' },
                            );
    
                        }
                        
                        evaluacionProveedorDatos.push(
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                            { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },
                        );

                        let params = {
                            evaluacionProveedorDatos,
                        }
                                      
                        commit('SET_DATOS', params);
                        resolve();
                    })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}